import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import { useLoading } from '../../../contexts/LoadingContext';
import { forgotPassword } from '../services/authService';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const { loading, setLoading } = useLoading();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await forgotPassword(email);

    if (response.success) {
      showSuccessToast(response.message);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }

    setLoading(false);
  };

  return (
    <div>
      <section id="login">
        <div className="left">
          <span>
            <img src="images/s&flogo.svg" alt="Logo" />
          </span>
        </div>
        <div className="right">
          <ForgotPasswordForm
            email={email}
            setEmail={setEmail}
            handleSubmit={handleSubmit}
            loading={loading}
          />
        </div>
      </section>
    </div>
  );
};

export default ForgotPasswordPage;
